import React from 'react';
import './Feature.css';

function Feature({id, value}) {
    return (
        <div className='feature'>
            <div className='feature_key'>{id}</div>
            <div className='feature_value'>{value}</div>
        </div>
    );
}

export default Feature;